import { Pill } from '@mantine/core';

import { Nomenclature } from '@feature/nomenclature';

export interface LanguagePillProps {
  language: Nomenclature | null;
}

export function LanguagePill({ language }: LanguagePillProps) {
  return <>{language && <Pill bg="green">{language.name}</Pill>}</>;
}
